<template>
  <v-container fluid class="fill-height d-block">
    <Loading v-if="loading" />
    <div class="fill-width withdrawal-details pa-2">
      <v-row
        class="fill-width flex-column ma-0"
        align="center"
        justify="center"
      >
        <v-icon size="80" contain>mdi-account</v-icon>
        <v-card-actions>
          <v-btn
            v-if="userInfo.userStatus === 'ACTIVE'"
            color="error"
            depressed
            @click="dialogActivity = true"
            >{{ $t("panel.usersPage.details.deactivate") }}</v-btn
          >
          <v-btn v-else color="primary" depressed @click="activateUser">{{
            $t("panel.usersPage.details.activate")
          }}</v-btn>
        </v-card-actions>
        <v-card-title
          >{{ $t("panel.usersPage.details.title") }}
          {{ userInfo.username }}</v-card-title
        >

        <v-chip
          class="text-center"
          :color="userInfo.userStatus === 'ACTIVE' ? 'primary' : 'error'"
          >{{ userInfo.userStatus }}</v-chip
        >

        <div class="align-self-start fill-width">
          <div
            v-for="(item, index) in $t('panel.usersPage.details.cardTitle')"
            :key="item.value"
          >
            <div class="d-flex align-center justify-start pa-3">
              <div class="width-auto pe-1 me-4">{{ item.text }}</div>
              <div
                v-if="!item.condition"
                class="width-auto font-medium-16 gray10--text ml-auto"
              >
                <div v-if="item.value === 'registerDate'">
                  {{ userInfo[item.value] | $renderDate }}
                </div>
                <div v-else>{{ userInfo[item.value] }}</div>
              </div>

              <v-btn
                v-else-if="item.value === 'View Details'"
                small
                color="primary"
                text
                @click="userAssets"
                class="ml-auto text-decoration-underline font-semiBold-14"
              >
                {{ item.value }}
              </v-btn>
              <div v-else-if="item.value === 'description'">
                <template v-for="(data, index) in userInfo.description">
                  <v-card :key="index">
                    <v-card-text>{{ data.date | $renderDate }}</v-card-text>
                    <v-card-text>{{ data.text }}</v-card-text>
                  </v-card>
                </template>
              </div>
            </div>
            <v-divider
              v-if="
                index !== $t('panel.usersPage.details.cardTitle').length - 1
              "
            />
          </div>
        </div>
      </v-row>

      <v-dialog v-model="dialogActivity" max-width="550px">
        <div class="pa-2">
          <v-form
            @submit.prevent="submit"
            class="d-flex flex-column justify-space-around align-center pa-7"
            ref="form"
          >
            <v-textarea
              v-model="modalDescription"
              :label="$t('panel.usersPage.details.modal.activity.label')"
              class="fill-width"
              outlined
              auto-grow
              rows="4"
              :rules="rules"
            />

            <v-btn
              color="primary"
              class="fill-width py-6 font-semiBold-16 mt-3"
              type="submit"
              :loading="submitLoading"
            >
              {{ $t("panel.usersPage.details.modal.activity.submit") }}
            </v-btn>
          </v-form>
        </div>
      </v-dialog>
      <v-dialog v-model="assetActivity" max-width="550px">
        <div class="pa-2">
          <v-row class="flex-column ma-0" align="center" justify="center">
            <v-icon size="80" contain>mdi-account</v-icon>
            <v-card-title class="pt-0"
              >{{ $t("panel.usersPage.details.modal.assets.title") }}
              {{ userInfo.username }}</v-card-title
            >
            <Loading v-if="userAssetsDialogLoading" />
            <template v-else>
              <template v-for="data in userAsset">
                <div
                  :key="data.iso + data.network"
                  class="fill-width assets-info"
                >
                  <div class="d-flex align-center justify-space-between pa-3">
                    <div class="width-auto pe-1">
                      {{ data.iso }} ({{ data.network }})
                    </div>
                    <div class="width-auto pe-1 text-truncate">
                      {{ data.remainAmount }}
                    </div>
                  </div>
                  <v-divider class="mx-3 assets-divider" />
                </div>
              </template>
              <!--              <template v-for="(data, key, index) in userInfo">-->
              <!--                <div-->
              <!--                  v-if="typeof data !== 'object'"-->
              <!--                  :key="index"-->
              <!--                  class="fill-width assets-info"-->
              <!--                >-->
              <!--                  <div class="d-flex align-center justify-space-between pa-3">-->
              <!--                    <div class="width-auto pe-1">{{ key }}</div>-->
              <!--                    <div class="width-auto pe-1 text-truncate">{{ data }}</div>-->
              <!--                  </div>-->
              <!--                  <v-divider class="mx-3 assets-divider" />-->
              <!--                </div>-->
              <!--              </template>-->
            </template>
          </v-row>
        </div>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { userService } from "@/services";
import renderDate from "@/mixins/renderDate";
import Loading from "@/components/Common/Loading";

export default {
  name: "users-details",
  components: { Loading },
  props: ["userId"],
  mixins: [renderDate],

  data() {
    return {
      loading: false,
      userInfo: {},
      dialogActivity: false,
      assetActivity: false,
      modalDescription: null,
      userAssetsDialogLoading: false,
      userAsset: null,
      rules: [
        v => !!v || this.$t("panel.usersPage.details.modal.activity.notEmpty")
      ],
      submitLoading: false
    };
  },
  created() {
    this.getUsersInfo();
  },
  methods: {
    userAssets() {
      this.assetActivity = true;
      this.userAssetsDialogLoading = true;
      userService
        .getUserAsset(this.userId)
        .then(response => {
          this.userAsset = [...response.data];
        })
        .finally(() => {
          this.userAssetsDialogLoading = false;
        });
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.submitLoading = true;
      userService
        .deactivateUser({
          description: this.modalDescription,
          userId: this.userId
        })
        .then(() => {
          this.dialogActivity = false;
          this.getUsersInfo();
          this.$refs.form.reset();
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    activateUser() {
      userService.activateUser({ userId: this.userId }).then(() => {
        this.getUsersInfo();
      });
    },
    getUsersInfo() {
      this.loading = true;
      userService
        .getUser(this.userId)
        .then(response => {
          this.userInfo = { ...response.data.data };
        })
        .finally(() => {
          this.loading = false;
        });
    }
    // itemDetails(val) {
    // return this.userInfo[val];
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "UsersDetails";
</style>
